import { createFileRoute } from '@tanstack/react-router';
import { CaptureSourcesPage } from '@web/modules/capture/sources/capture-sources-page';

export const Route = createFileRoute('/_app/capture/sources')({
  component: CaptureSourcesPage,
});
